/**
 * @generated SignedSource<<2a8c6b0ae59e1bccbc4ed392f6159891>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeWorkStatus = "NOT_WORKING" | "WORKING";
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
export type RoutineScheduleType = "DAILY" | "MONTHLY" | "WEEKLY";
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type WidgetTeamScheduleDisplayType = "DAILY" | "DAILY_WITH_SUMMARY" | "MONTHLY" | "WEEKLY";
export type PreviewWidgetTeamScheduleInput = {
  roleIds?: ReadonlyArray<string> | null;
  size?: WidgetOverviewSize | null;
  storecastId?: string | null;
  teamIds?: ReadonlyArray<string> | null;
  type?: WidgetTeamScheduleDisplayType | null;
  withoutRoleSelected?: boolean | null;
};
export type WidgetTeamScheduleMockPreviewQuery$variables = {
  input: PreviewWidgetTeamScheduleInput;
  storecastId: string;
};
export type WidgetTeamScheduleMockPreviewQuery$data = {
  readonly dashboard: {
    readonly previewWidgetTeamSchedule: {
      readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamSchedule_widget">;
    };
  };
};
export type WidgetTeamScheduleMockPreviewQuery$rawResponse = {
  readonly dashboard: {
    readonly id: string;
    readonly previewWidgetTeamSchedule: {
      readonly content: {
        readonly __typename: "WidgetTeamScheduleContentDaily";
        readonly dailyTeamSchedule: {
          readonly events: ReadonlyArray<{
            readonly __typename: "RoutineOccasion";
            readonly __isTeamScheduleEventOccasion: "RoutineOccasion";
            readonly assigned: ReadonlyArray<{
              readonly employee: {
                readonly id: string;
                readonly image: {
                  readonly __typename: "Image";
                  readonly __isPublicAndInternalImage: "Image";
                  readonly id: string;
                  readonly sizes: ReadonlyArray<{
                    readonly height: number;
                    readonly id: string;
                    readonly url: string;
                    readonly urlExpiresAt: string | null;
                    readonly width: number;
                  }>;
                  readonly thumbhash: string | null;
                } | {
                  readonly __typename: "PublicImage";
                  readonly __isPublicAndInternalImage: "PublicImage";
                  readonly publicImageUrl: string;
                } | {
                  readonly __typename: string;
                  readonly __isPublicAndInternalImage: string;
                } | null;
                readonly isLinkedToViewer: boolean;
                readonly name: string;
                readonly workStatus: EmployeeWorkStatus;
              } | null;
              readonly id: string;
            }>;
            readonly assignedRoles: ReadonlyArray<{
              readonly id: string;
              readonly role: {
                readonly employeeIds: ReadonlyArray<string>;
                readonly employees: ReadonlyArray<{
                  readonly id: string;
                  readonly image: {
                    readonly __typename: "Image";
                    readonly __isPublicAndInternalImage: "Image";
                    readonly id: string;
                    readonly sizes: ReadonlyArray<{
                      readonly height: number;
                      readonly id: string;
                      readonly url: string;
                      readonly urlExpiresAt: string | null;
                      readonly width: number;
                    }>;
                    readonly thumbhash: string | null;
                  } | {
                    readonly __typename: "PublicImage";
                    readonly __isPublicAndInternalImage: "PublicImage";
                    readonly publicImageUrl: string;
                  } | {
                    readonly __typename: string;
                    readonly __isPublicAndInternalImage: string;
                  } | null;
                  readonly isLinkedToViewer: boolean;
                  readonly name: string;
                  readonly workStatus: EmployeeWorkStatus;
                }>;
                readonly id: string;
                readonly isLinkedToViewer: boolean;
                readonly name: string;
                readonly team: {
                  readonly id: string;
                };
              };
            }>;
            readonly deadlineAt: string | null;
            readonly expireAt: string;
            readonly id: string;
            readonly issueCount: number;
            readonly routine: {
              readonly description: string | null;
              readonly descriptionImages: ReadonlyArray<{
                readonly id: string;
                readonly size: {
                  readonly id: string;
                  readonly url: string;
                } | null;
              }>;
              readonly id: string;
              readonly isOrg: boolean;
              readonly orgIconUri: string | null;
              readonly title: string;
            };
            readonly sequenceNumber: number;
            readonly startAt: string;
            readonly status: RoutineOccasionStatus;
            readonly totalTaskExecutionCount: number | null;
          } | {
            readonly __typename: "TeamScheduleInlineRoutineOccasion";
            readonly __isTeamScheduleEventOccasion: "TeamScheduleInlineRoutineOccasion";
            readonly id: string;
            readonly startAt: string;
            readonly taskExecution: {
              readonly checkValue: TaskSentiment | null;
              readonly id: string;
              readonly routine: {
                readonly description: string | null;
                readonly descriptionImages: ReadonlyArray<{
                  readonly id: string;
                  readonly size: {
                    readonly id: string;
                    readonly url: string;
                  } | null;
                }>;
                readonly id: string;
                readonly isOrg: boolean;
                readonly orgIconUri: string | null;
                readonly title: string;
              } | null;
              readonly routineOccasion: {
                readonly __typename: "RoutineOccasion";
                readonly assigned: ReadonlyArray<{
                  readonly employee: {
                    readonly id: string;
                    readonly image: {
                      readonly __typename: "Image";
                      readonly __isPublicAndInternalImage: "Image";
                      readonly id: string;
                      readonly sizes: ReadonlyArray<{
                        readonly height: number;
                        readonly id: string;
                        readonly url: string;
                        readonly urlExpiresAt: string | null;
                        readonly width: number;
                      }>;
                      readonly thumbhash: string | null;
                    } | {
                      readonly __typename: "PublicImage";
                      readonly __isPublicAndInternalImage: "PublicImage";
                      readonly publicImageUrl: string;
                    } | {
                      readonly __typename: string;
                      readonly __isPublicAndInternalImage: string;
                    } | null;
                    readonly isLinkedToViewer: boolean;
                    readonly name: string;
                    readonly workStatus: EmployeeWorkStatus;
                  } | null;
                  readonly id: string;
                }>;
                readonly assignedRoles: ReadonlyArray<{
                  readonly id: string;
                  readonly role: {
                    readonly employeeIds: ReadonlyArray<string>;
                    readonly employees: ReadonlyArray<{
                      readonly id: string;
                      readonly image: {
                        readonly __typename: "Image";
                        readonly __isPublicAndInternalImage: "Image";
                        readonly id: string;
                        readonly sizes: ReadonlyArray<{
                          readonly height: number;
                          readonly id: string;
                          readonly url: string;
                          readonly urlExpiresAt: string | null;
                          readonly width: number;
                        }>;
                        readonly thumbhash: string | null;
                      } | {
                        readonly __typename: "PublicImage";
                        readonly __isPublicAndInternalImage: "PublicImage";
                        readonly publicImageUrl: string;
                      } | {
                        readonly __typename: string;
                        readonly __isPublicAndInternalImage: string;
                      } | null;
                      readonly isLinkedToViewer: boolean;
                      readonly name: string;
                      readonly workStatus: EmployeeWorkStatus;
                    }>;
                    readonly id: string;
                    readonly isLinkedToViewer: boolean;
                    readonly name: string;
                    readonly team: {
                      readonly id: string;
                    };
                  };
                }>;
                readonly deadlineAt: string | null;
                readonly id: string;
                readonly issueCount: number;
                readonly sequenceNumber: number;
                readonly startAt: string;
                readonly status: RoutineOccasionStatus;
                readonly store: {
                  readonly id: string;
                  readonly myRole: Roles;
                } | null;
                readonly totalTaskExecutionCount: number | null;
              };
              readonly sectionId: string;
              readonly task: {
                readonly id: string;
              };
            };
          } | {
            readonly __typename: string;
            readonly __isTeamScheduleEventOccasion: string;
            readonly id: string;
            readonly startAt: string;
          }>;
          readonly freq: RoutineScheduleType;
          readonly id: string;
          readonly label: string;
        };
      } | {
        readonly __typename: "WidgetTeamScheduleContentMonthly";
        readonly monthlyTeamSchedule: {
          readonly events: ReadonlyArray<{
            readonly __typename: "RoutineOccasion";
            readonly __isTeamScheduleEventOccasion: "RoutineOccasion";
            readonly assigned: ReadonlyArray<{
              readonly employee: {
                readonly id: string;
                readonly image: {
                  readonly __typename: "Image";
                  readonly __isPublicAndInternalImage: "Image";
                  readonly id: string;
                  readonly sizes: ReadonlyArray<{
                    readonly height: number;
                    readonly id: string;
                    readonly url: string;
                    readonly urlExpiresAt: string | null;
                    readonly width: number;
                  }>;
                  readonly thumbhash: string | null;
                } | {
                  readonly __typename: "PublicImage";
                  readonly __isPublicAndInternalImage: "PublicImage";
                  readonly publicImageUrl: string;
                } | {
                  readonly __typename: string;
                  readonly __isPublicAndInternalImage: string;
                } | null;
                readonly isLinkedToViewer: boolean;
                readonly name: string;
                readonly workStatus: EmployeeWorkStatus;
              } | null;
              readonly id: string;
            }>;
            readonly assignedRoles: ReadonlyArray<{
              readonly id: string;
              readonly role: {
                readonly employeeIds: ReadonlyArray<string>;
                readonly employees: ReadonlyArray<{
                  readonly id: string;
                  readonly image: {
                    readonly __typename: "Image";
                    readonly __isPublicAndInternalImage: "Image";
                    readonly id: string;
                    readonly sizes: ReadonlyArray<{
                      readonly height: number;
                      readonly id: string;
                      readonly url: string;
                      readonly urlExpiresAt: string | null;
                      readonly width: number;
                    }>;
                    readonly thumbhash: string | null;
                  } | {
                    readonly __typename: "PublicImage";
                    readonly __isPublicAndInternalImage: "PublicImage";
                    readonly publicImageUrl: string;
                  } | {
                    readonly __typename: string;
                    readonly __isPublicAndInternalImage: string;
                  } | null;
                  readonly isLinkedToViewer: boolean;
                  readonly name: string;
                  readonly workStatus: EmployeeWorkStatus;
                }>;
                readonly id: string;
                readonly isLinkedToViewer: boolean;
                readonly name: string;
                readonly team: {
                  readonly id: string;
                };
              };
            }>;
            readonly deadlineAt: string | null;
            readonly expireAt: string;
            readonly id: string;
            readonly issueCount: number;
            readonly routine: {
              readonly description: string | null;
              readonly descriptionImages: ReadonlyArray<{
                readonly id: string;
                readonly size: {
                  readonly id: string;
                  readonly url: string;
                } | null;
              }>;
              readonly id: string;
              readonly isOrg: boolean;
              readonly orgIconUri: string | null;
              readonly title: string;
            };
            readonly sequenceNumber: number;
            readonly startAt: string;
            readonly status: RoutineOccasionStatus;
            readonly totalTaskExecutionCount: number | null;
          } | {
            readonly __typename: "TeamScheduleInlineRoutineOccasion";
            readonly __isTeamScheduleEventOccasion: "TeamScheduleInlineRoutineOccasion";
            readonly id: string;
            readonly startAt: string;
            readonly taskExecution: {
              readonly checkValue: TaskSentiment | null;
              readonly id: string;
              readonly routine: {
                readonly description: string | null;
                readonly descriptionImages: ReadonlyArray<{
                  readonly id: string;
                  readonly size: {
                    readonly id: string;
                    readonly url: string;
                  } | null;
                }>;
                readonly id: string;
                readonly isOrg: boolean;
                readonly orgIconUri: string | null;
                readonly title: string;
              } | null;
              readonly routineOccasion: {
                readonly __typename: "RoutineOccasion";
                readonly assigned: ReadonlyArray<{
                  readonly employee: {
                    readonly id: string;
                    readonly image: {
                      readonly __typename: "Image";
                      readonly __isPublicAndInternalImage: "Image";
                      readonly id: string;
                      readonly sizes: ReadonlyArray<{
                        readonly height: number;
                        readonly id: string;
                        readonly url: string;
                        readonly urlExpiresAt: string | null;
                        readonly width: number;
                      }>;
                      readonly thumbhash: string | null;
                    } | {
                      readonly __typename: "PublicImage";
                      readonly __isPublicAndInternalImage: "PublicImage";
                      readonly publicImageUrl: string;
                    } | {
                      readonly __typename: string;
                      readonly __isPublicAndInternalImage: string;
                    } | null;
                    readonly isLinkedToViewer: boolean;
                    readonly name: string;
                    readonly workStatus: EmployeeWorkStatus;
                  } | null;
                  readonly id: string;
                }>;
                readonly assignedRoles: ReadonlyArray<{
                  readonly id: string;
                  readonly role: {
                    readonly employeeIds: ReadonlyArray<string>;
                    readonly employees: ReadonlyArray<{
                      readonly id: string;
                      readonly image: {
                        readonly __typename: "Image";
                        readonly __isPublicAndInternalImage: "Image";
                        readonly id: string;
                        readonly sizes: ReadonlyArray<{
                          readonly height: number;
                          readonly id: string;
                          readonly url: string;
                          readonly urlExpiresAt: string | null;
                          readonly width: number;
                        }>;
                        readonly thumbhash: string | null;
                      } | {
                        readonly __typename: "PublicImage";
                        readonly __isPublicAndInternalImage: "PublicImage";
                        readonly publicImageUrl: string;
                      } | {
                        readonly __typename: string;
                        readonly __isPublicAndInternalImage: string;
                      } | null;
                      readonly isLinkedToViewer: boolean;
                      readonly name: string;
                      readonly workStatus: EmployeeWorkStatus;
                    }>;
                    readonly id: string;
                    readonly isLinkedToViewer: boolean;
                    readonly name: string;
                    readonly team: {
                      readonly id: string;
                    };
                  };
                }>;
                readonly deadlineAt: string | null;
                readonly id: string;
                readonly issueCount: number;
                readonly sequenceNumber: number;
                readonly startAt: string;
                readonly status: RoutineOccasionStatus;
                readonly store: {
                  readonly id: string;
                  readonly myRole: Roles;
                } | null;
                readonly totalTaskExecutionCount: number | null;
              };
              readonly sectionId: string;
              readonly task: {
                readonly id: string;
              };
            };
          } | {
            readonly __typename: string;
            readonly __isTeamScheduleEventOccasion: string;
            readonly id: string;
            readonly startAt: string;
          }>;
          readonly freq: RoutineScheduleType;
          readonly id: string;
          readonly label: string;
        };
      } | {
        readonly __typename: "WidgetTeamScheduleContentSummary";
        readonly dailyTeamSchedule: {
          readonly events: ReadonlyArray<{
            readonly __typename: "RoutineOccasion";
            readonly __isTeamScheduleEventOccasion: "RoutineOccasion";
            readonly assigned: ReadonlyArray<{
              readonly employee: {
                readonly id: string;
                readonly image: {
                  readonly __typename: "Image";
                  readonly __isPublicAndInternalImage: "Image";
                  readonly id: string;
                  readonly sizes: ReadonlyArray<{
                    readonly height: number;
                    readonly id: string;
                    readonly url: string;
                    readonly urlExpiresAt: string | null;
                    readonly width: number;
                  }>;
                  readonly thumbhash: string | null;
                } | {
                  readonly __typename: "PublicImage";
                  readonly __isPublicAndInternalImage: "PublicImage";
                  readonly publicImageUrl: string;
                } | {
                  readonly __typename: string;
                  readonly __isPublicAndInternalImage: string;
                } | null;
                readonly isLinkedToViewer: boolean;
                readonly name: string;
                readonly workStatus: EmployeeWorkStatus;
              } | null;
              readonly id: string;
            }>;
            readonly assignedRoles: ReadonlyArray<{
              readonly id: string;
              readonly role: {
                readonly employeeIds: ReadonlyArray<string>;
                readonly employees: ReadonlyArray<{
                  readonly id: string;
                  readonly image: {
                    readonly __typename: "Image";
                    readonly __isPublicAndInternalImage: "Image";
                    readonly id: string;
                    readonly sizes: ReadonlyArray<{
                      readonly height: number;
                      readonly id: string;
                      readonly url: string;
                      readonly urlExpiresAt: string | null;
                      readonly width: number;
                    }>;
                    readonly thumbhash: string | null;
                  } | {
                    readonly __typename: "PublicImage";
                    readonly __isPublicAndInternalImage: "PublicImage";
                    readonly publicImageUrl: string;
                  } | {
                    readonly __typename: string;
                    readonly __isPublicAndInternalImage: string;
                  } | null;
                  readonly isLinkedToViewer: boolean;
                  readonly name: string;
                  readonly workStatus: EmployeeWorkStatus;
                }>;
                readonly id: string;
                readonly isLinkedToViewer: boolean;
                readonly name: string;
                readonly team: {
                  readonly id: string;
                };
              };
            }>;
            readonly deadlineAt: string | null;
            readonly expireAt: string;
            readonly id: string;
            readonly issueCount: number;
            readonly routine: {
              readonly description: string | null;
              readonly descriptionImages: ReadonlyArray<{
                readonly id: string;
                readonly size: {
                  readonly id: string;
                  readonly url: string;
                } | null;
              }>;
              readonly id: string;
              readonly isOrg: boolean;
              readonly orgIconUri: string | null;
              readonly title: string;
            };
            readonly sequenceNumber: number;
            readonly startAt: string;
            readonly status: RoutineOccasionStatus;
            readonly totalTaskExecutionCount: number | null;
          } | {
            readonly __typename: "TeamScheduleInlineRoutineOccasion";
            readonly __isTeamScheduleEventOccasion: "TeamScheduleInlineRoutineOccasion";
            readonly id: string;
            readonly startAt: string;
            readonly taskExecution: {
              readonly checkValue: TaskSentiment | null;
              readonly id: string;
              readonly routine: {
                readonly description: string | null;
                readonly descriptionImages: ReadonlyArray<{
                  readonly id: string;
                  readonly size: {
                    readonly id: string;
                    readonly url: string;
                  } | null;
                }>;
                readonly id: string;
                readonly isOrg: boolean;
                readonly orgIconUri: string | null;
                readonly title: string;
              } | null;
              readonly routineOccasion: {
                readonly __typename: "RoutineOccasion";
                readonly assigned: ReadonlyArray<{
                  readonly employee: {
                    readonly id: string;
                    readonly image: {
                      readonly __typename: "Image";
                      readonly __isPublicAndInternalImage: "Image";
                      readonly id: string;
                      readonly sizes: ReadonlyArray<{
                        readonly height: number;
                        readonly id: string;
                        readonly url: string;
                        readonly urlExpiresAt: string | null;
                        readonly width: number;
                      }>;
                      readonly thumbhash: string | null;
                    } | {
                      readonly __typename: "PublicImage";
                      readonly __isPublicAndInternalImage: "PublicImage";
                      readonly publicImageUrl: string;
                    } | {
                      readonly __typename: string;
                      readonly __isPublicAndInternalImage: string;
                    } | null;
                    readonly isLinkedToViewer: boolean;
                    readonly name: string;
                    readonly workStatus: EmployeeWorkStatus;
                  } | null;
                  readonly id: string;
                }>;
                readonly assignedRoles: ReadonlyArray<{
                  readonly id: string;
                  readonly role: {
                    readonly employeeIds: ReadonlyArray<string>;
                    readonly employees: ReadonlyArray<{
                      readonly id: string;
                      readonly image: {
                        readonly __typename: "Image";
                        readonly __isPublicAndInternalImage: "Image";
                        readonly id: string;
                        readonly sizes: ReadonlyArray<{
                          readonly height: number;
                          readonly id: string;
                          readonly url: string;
                          readonly urlExpiresAt: string | null;
                          readonly width: number;
                        }>;
                        readonly thumbhash: string | null;
                      } | {
                        readonly __typename: "PublicImage";
                        readonly __isPublicAndInternalImage: "PublicImage";
                        readonly publicImageUrl: string;
                      } | {
                        readonly __typename: string;
                        readonly __isPublicAndInternalImage: string;
                      } | null;
                      readonly isLinkedToViewer: boolean;
                      readonly name: string;
                      readonly workStatus: EmployeeWorkStatus;
                    }>;
                    readonly id: string;
                    readonly isLinkedToViewer: boolean;
                    readonly name: string;
                    readonly team: {
                      readonly id: string;
                    };
                  };
                }>;
                readonly deadlineAt: string | null;
                readonly id: string;
                readonly issueCount: number;
                readonly sequenceNumber: number;
                readonly startAt: string;
                readonly status: RoutineOccasionStatus;
                readonly store: {
                  readonly id: string;
                  readonly myRole: Roles;
                } | null;
                readonly totalTaskExecutionCount: number | null;
              };
              readonly sectionId: string;
              readonly task: {
                readonly id: string;
              };
            };
          } | {
            readonly __typename: string;
            readonly __isTeamScheduleEventOccasion: string;
            readonly id: string;
            readonly startAt: string;
          }>;
          readonly freq: RoutineScheduleType;
          readonly id: string;
          readonly label: string;
        };
        readonly monthlyTeamSchedule: {
          readonly events: ReadonlyArray<{
            readonly __typename: "RoutineOccasion";
            readonly id: string;
            readonly status: RoutineOccasionStatus;
            readonly totalTaskExecutionCount: number | null;
          } | {
            readonly __typename: "TeamScheduleInlineRoutineOccasion";
            readonly id: string;
            readonly taskExecution: {
              readonly id: string;
              readonly routineOccasion: {
                readonly __typename: "RoutineOccasion";
                readonly id: string;
                readonly status: RoutineOccasionStatus;
                readonly totalTaskExecutionCount: number | null;
              };
            };
          } | {
            readonly __typename: string;
            readonly id: string;
          }>;
          readonly freq: RoutineScheduleType;
          readonly id: string;
          readonly label: string;
        };
        readonly weeklyTeamSchedule: {
          readonly events: ReadonlyArray<{
            readonly __typename: "RoutineOccasion";
            readonly id: string;
            readonly status: RoutineOccasionStatus;
            readonly totalTaskExecutionCount: number | null;
          } | {
            readonly __typename: "TeamScheduleInlineRoutineOccasion";
            readonly id: string;
            readonly taskExecution: {
              readonly id: string;
              readonly routineOccasion: {
                readonly __typename: "RoutineOccasion";
                readonly id: string;
                readonly status: RoutineOccasionStatus;
                readonly totalTaskExecutionCount: number | null;
              };
            };
          } | {
            readonly __typename: string;
            readonly id: string;
          }>;
          readonly freq: RoutineScheduleType;
          readonly id: string;
          readonly label: string;
        };
      } | {
        readonly __typename: "WidgetTeamScheduleContentWeekly";
        readonly weeklyTeamSchedule: {
          readonly events: ReadonlyArray<{
            readonly __typename: "RoutineOccasion";
            readonly __isTeamScheduleEventOccasion: "RoutineOccasion";
            readonly assigned: ReadonlyArray<{
              readonly employee: {
                readonly id: string;
                readonly image: {
                  readonly __typename: "Image";
                  readonly __isPublicAndInternalImage: "Image";
                  readonly id: string;
                  readonly sizes: ReadonlyArray<{
                    readonly height: number;
                    readonly id: string;
                    readonly url: string;
                    readonly urlExpiresAt: string | null;
                    readonly width: number;
                  }>;
                  readonly thumbhash: string | null;
                } | {
                  readonly __typename: "PublicImage";
                  readonly __isPublicAndInternalImage: "PublicImage";
                  readonly publicImageUrl: string;
                } | {
                  readonly __typename: string;
                  readonly __isPublicAndInternalImage: string;
                } | null;
                readonly isLinkedToViewer: boolean;
                readonly name: string;
                readonly workStatus: EmployeeWorkStatus;
              } | null;
              readonly id: string;
            }>;
            readonly assignedRoles: ReadonlyArray<{
              readonly id: string;
              readonly role: {
                readonly employeeIds: ReadonlyArray<string>;
                readonly employees: ReadonlyArray<{
                  readonly id: string;
                  readonly image: {
                    readonly __typename: "Image";
                    readonly __isPublicAndInternalImage: "Image";
                    readonly id: string;
                    readonly sizes: ReadonlyArray<{
                      readonly height: number;
                      readonly id: string;
                      readonly url: string;
                      readonly urlExpiresAt: string | null;
                      readonly width: number;
                    }>;
                    readonly thumbhash: string | null;
                  } | {
                    readonly __typename: "PublicImage";
                    readonly __isPublicAndInternalImage: "PublicImage";
                    readonly publicImageUrl: string;
                  } | {
                    readonly __typename: string;
                    readonly __isPublicAndInternalImage: string;
                  } | null;
                  readonly isLinkedToViewer: boolean;
                  readonly name: string;
                  readonly workStatus: EmployeeWorkStatus;
                }>;
                readonly id: string;
                readonly isLinkedToViewer: boolean;
                readonly name: string;
                readonly team: {
                  readonly id: string;
                };
              };
            }>;
            readonly deadlineAt: string | null;
            readonly expireAt: string;
            readonly id: string;
            readonly issueCount: number;
            readonly routine: {
              readonly description: string | null;
              readonly descriptionImages: ReadonlyArray<{
                readonly id: string;
                readonly size: {
                  readonly id: string;
                  readonly url: string;
                } | null;
              }>;
              readonly id: string;
              readonly isOrg: boolean;
              readonly orgIconUri: string | null;
              readonly title: string;
            };
            readonly sequenceNumber: number;
            readonly startAt: string;
            readonly status: RoutineOccasionStatus;
            readonly totalTaskExecutionCount: number | null;
          } | {
            readonly __typename: "TeamScheduleInlineRoutineOccasion";
            readonly __isTeamScheduleEventOccasion: "TeamScheduleInlineRoutineOccasion";
            readonly id: string;
            readonly startAt: string;
            readonly taskExecution: {
              readonly checkValue: TaskSentiment | null;
              readonly id: string;
              readonly routine: {
                readonly description: string | null;
                readonly descriptionImages: ReadonlyArray<{
                  readonly id: string;
                  readonly size: {
                    readonly id: string;
                    readonly url: string;
                  } | null;
                }>;
                readonly id: string;
                readonly isOrg: boolean;
                readonly orgIconUri: string | null;
                readonly title: string;
              } | null;
              readonly routineOccasion: {
                readonly __typename: "RoutineOccasion";
                readonly assigned: ReadonlyArray<{
                  readonly employee: {
                    readonly id: string;
                    readonly image: {
                      readonly __typename: "Image";
                      readonly __isPublicAndInternalImage: "Image";
                      readonly id: string;
                      readonly sizes: ReadonlyArray<{
                        readonly height: number;
                        readonly id: string;
                        readonly url: string;
                        readonly urlExpiresAt: string | null;
                        readonly width: number;
                      }>;
                      readonly thumbhash: string | null;
                    } | {
                      readonly __typename: "PublicImage";
                      readonly __isPublicAndInternalImage: "PublicImage";
                      readonly publicImageUrl: string;
                    } | {
                      readonly __typename: string;
                      readonly __isPublicAndInternalImage: string;
                    } | null;
                    readonly isLinkedToViewer: boolean;
                    readonly name: string;
                    readonly workStatus: EmployeeWorkStatus;
                  } | null;
                  readonly id: string;
                }>;
                readonly assignedRoles: ReadonlyArray<{
                  readonly id: string;
                  readonly role: {
                    readonly employeeIds: ReadonlyArray<string>;
                    readonly employees: ReadonlyArray<{
                      readonly id: string;
                      readonly image: {
                        readonly __typename: "Image";
                        readonly __isPublicAndInternalImage: "Image";
                        readonly id: string;
                        readonly sizes: ReadonlyArray<{
                          readonly height: number;
                          readonly id: string;
                          readonly url: string;
                          readonly urlExpiresAt: string | null;
                          readonly width: number;
                        }>;
                        readonly thumbhash: string | null;
                      } | {
                        readonly __typename: "PublicImage";
                        readonly __isPublicAndInternalImage: "PublicImage";
                        readonly publicImageUrl: string;
                      } | {
                        readonly __typename: string;
                        readonly __isPublicAndInternalImage: string;
                      } | null;
                      readonly isLinkedToViewer: boolean;
                      readonly name: string;
                      readonly workStatus: EmployeeWorkStatus;
                    }>;
                    readonly id: string;
                    readonly isLinkedToViewer: boolean;
                    readonly name: string;
                    readonly team: {
                      readonly id: string;
                    };
                  };
                }>;
                readonly deadlineAt: string | null;
                readonly id: string;
                readonly issueCount: number;
                readonly sequenceNumber: number;
                readonly startAt: string;
                readonly status: RoutineOccasionStatus;
                readonly store: {
                  readonly id: string;
                  readonly myRole: Roles;
                } | null;
                readonly totalTaskExecutionCount: number | null;
              };
              readonly sectionId: string;
              readonly task: {
                readonly id: string;
              };
            };
          } | {
            readonly __typename: string;
            readonly __isTeamScheduleEventOccasion: string;
            readonly id: string;
            readonly startAt: string;
          }>;
          readonly freq: RoutineScheduleType;
          readonly id: string;
          readonly label: string;
        };
      } | {
        readonly __typename: string;
      } | null;
      readonly id: string;
      readonly overviewSize: WidgetOverviewSize;
      readonly teams: ReadonlyArray<{
        readonly color: string | null;
        readonly id: string;
      }>;
      readonly title: string;
    };
  } | null;
};
export type WidgetTeamScheduleMockPreviewQuery = {
  rawResponse: WidgetTeamScheduleMockPreviewQuery$rawResponse;
  response: WidgetTeamScheduleMockPreviewQuery$data;
  variables: WidgetTeamScheduleMockPreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "freq",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "includeInlineRoutines",
    "value": true
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Routine",
  "kind": "LinkedField",
  "name": "routine",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "minHeight",
              "value": 120
            },
            {
              "kind": "Literal",
              "name": "minWidth",
              "value": 120
            }
          ],
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "size",
          "plural": false,
          "selections": [
            (v11/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": "size(minHeight:120,minWidth:120)"
        }
      ],
      "storageKey": null
    },
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgIconUri",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "calculateNotCompletedStarted",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueCount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkedToViewer",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbhash",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            (v11/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlExpiresAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedEmployee",
  "kind": "LinkedField",
  "name": "assigned",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = [
  (v4/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedRole",
  "kind": "LinkedField",
  "name": "assignedRoles",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeRole",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employeeIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "team",
          "plural": false,
          "selections": (v22/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employees",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v20/*: any*/),
            (v19/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaskExecutionCount",
  "storageKey": null
},
v25 = [
  (v4/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": (v9/*: any*/),
    "concreteType": null,
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      (v6/*: any*/),
      (v4/*: any*/),
      (v10/*: any*/),
      {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isTeamScheduleEventOccasion"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expireAt",
            "storageKey": null
          },
          (v16/*: any*/),
          (v21/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/)
        ],
        "type": "RoutineOccasion",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskExecutionCheck",
            "kind": "LinkedField",
            "name": "taskExecution",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "routineOccasion",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "myRole",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v21/*: any*/),
                  (v23/*: any*/),
                  (v16/*: any*/),
                  (v15/*: any*/),
                  (v6/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskCheck",
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": (v22/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sectionId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "checkValue",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "TeamScheduleInlineRoutineOccasion",
        "abstractKey": null
      }
    ],
    "storageKey": "events(includeInlineRoutines:true)"
  }
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamSchedule",
  "kind": "LinkedField",
  "name": "dailyTeamSchedule",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v27 = [
  (v4/*: any*/),
  (v8/*: any*/),
  (v7/*: any*/),
  {
    "alias": null,
    "args": (v9/*: any*/),
    "concreteType": null,
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      (v6/*: any*/),
      (v4/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v15/*: any*/),
          (v24/*: any*/)
        ],
        "type": "RoutineOccasion",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskExecutionCheck",
            "kind": "LinkedField",
            "name": "taskExecution",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "routineOccasion",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v6/*: any*/),
                  (v24/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "TeamScheduleInlineRoutineOccasion",
        "abstractKey": null
      }
    ],
    "storageKey": "events(includeInlineRoutines:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetTeamScheduleMockPreviewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v3/*: any*/),
              "concreteType": "WidgetTeamSchedule",
              "kind": "LinkedField",
              "name": "previewWidgetTeamSchedule",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WidgetTeamSchedule_widget"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WidgetTeamScheduleMockPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "WidgetTeamSchedule",
            "kind": "LinkedField",
            "name": "previewWidgetTeamSchedule",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "overviewSize",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v26/*: any*/)
                    ],
                    "type": "WidgetTeamScheduleContentDaily",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamSchedule",
                        "kind": "LinkedField",
                        "name": "weeklyTeamSchedule",
                        "plural": false,
                        "selections": (v25/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTeamScheduleContentWeekly",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamSchedule",
                        "kind": "LinkedField",
                        "name": "monthlyTeamSchedule",
                        "plural": false,
                        "selections": (v25/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTeamScheduleContentMonthly",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v26/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamSchedule",
                        "kind": "LinkedField",
                        "name": "weeklyTeamSchedule",
                        "plural": false,
                        "selections": (v27/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamSchedule",
                        "kind": "LinkedField",
                        "name": "monthlyTeamSchedule",
                        "plural": false,
                        "selections": (v27/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTeamScheduleContentSummary",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a369e964a6a23380e1d9397507062f6b",
    "id": null,
    "metadata": {},
    "name": "WidgetTeamScheduleMockPreviewQuery",
    "operationKind": "query",
    "text": "query WidgetTeamScheduleMockPreviewQuery(\n  $storecastId: ID!\n  $input: PreviewWidgetTeamScheduleInput!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetTeamSchedule(input: $input) {\n      ...WidgetTeamSchedule_widget\n      id\n    }\n    id\n  }\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment ListItemAssignees_employees on Employee {\n  id\n  ...ListItemEmployees_employees\n}\n\nfragment ListItemAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment ListItemEmployees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ListItemRoles_roles on EmployeeRole {\n  id\n  name\n  isLinkedToViewer\n  employeeIds\n  team {\n    id\n  }\n  employees {\n    id\n    name\n    isLinkedToViewer\n    workStatus\n    ...Avatar_employee\n  }\n}\n\nfragment RoutineOccasionStatusCircleInline_RoutineOccasion on RoutineOccasion {\n  id\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  deadlineAt\n  startAt\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment ToolbarButtonAssignees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ToolbarButtonAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily on WidgetTeamScheduleContentDaily {\n  dailyTeamSchedule {\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      ...useNowIndexes_teamScheduleEventOccasion\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetTeamScheduleContentList_teamSchedule on TeamSchedule {\n  id\n  label\n  freq\n  events(includeInlineRoutines: true) {\n    __typename\n    id\n    startAt\n    ... on RoutineOccasion {\n      routine {\n        id\n        description\n        descriptionImages {\n          id\n        }\n      }\n    }\n    ... on TeamScheduleInlineRoutineOccasion {\n      taskExecution {\n        routine {\n          id\n          description\n          descriptionImages {\n            id\n          }\n        }\n        id\n      }\n    }\n    ...useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion\n    ...WidgetTeamScheduleListItem_item\n  }\n}\n\nfragment WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly on WidgetTeamScheduleContentMonthly {\n  monthlyTeamSchedule {\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    ...WidgetTeamScheduleContentStatus_teamSchedule\n    id\n  }\n}\n\nfragment WidgetTeamScheduleContentSectionHeader_teamSchedule on TeamSchedule {\n  id\n  freq\n  label\n  ...WidgetTeamScheduleContentStatus_teamSchedule\n}\n\nfragment WidgetTeamScheduleContentStatus_teamSchedule on TeamSchedule {\n  events(includeInlineRoutines: true) {\n    __typename\n    id\n    ... on RoutineOccasion {\n      __typename\n      status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n      ...WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion\n    }\n    ... on TeamScheduleInlineRoutineOccasion {\n      __typename\n      taskExecution {\n        routineOccasion {\n          status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n          __typename\n          ...WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary on WidgetTeamScheduleContentSummary {\n  dailyTeamSchedule {\n    id\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n      ...useNowIndexes_teamScheduleEventOccasion\n    }\n  }\n  weeklyTeamSchedule {\n    id\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n    }\n  }\n  monthlyTeamSchedule {\n    id\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n    }\n  }\n}\n\nfragment WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly on WidgetTeamScheduleContentWeekly {\n  weeklyTeamSchedule {\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    id\n  }\n}\n\nfragment WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion on TeamScheduleInlineRoutineOccasion {\n  id\n  taskExecution {\n    id\n    task {\n      id\n    }\n    sectionId\n    routineOccasion {\n      id\n      store {\n        myRole\n        id\n      }\n      sequenceNumber\n      ...WidgetTeamScheduleRoutineListItemContent_RoutineOccasion\n      ...WidgetTeamScheduleRoutineIssueIndicator_routineOccasion\n      ...RoutineOccasionStatusCircleInline_RoutineOccasion\n    }\n    routine {\n      id\n      ...WidgetTeamScheduleRoutineListItemContent_Routine\n    }\n    checkValue\n  }\n}\n\nfragment WidgetTeamScheduleListItem_item on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  ... on TeamScheduleInlineRoutineOccasion {\n    id\n    startAt\n    taskExecution {\n      routineOccasion {\n        deadlineAt\n        sequenceNumber\n        id\n      }\n      routine {\n        id\n      }\n      id\n    }\n    __typename\n    ...WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion\n  }\n  ... on RoutineOccasion {\n    id\n    __typename\n    startAt\n    deadlineAt\n    sequenceNumber\n    routine {\n      id\n    }\n    ...WidgetTeamScheduleRoutineOccasionListItem_item\n  }\n}\n\nfragment WidgetTeamScheduleRoutineIssueIndicator_routineOccasion on RoutineOccasion {\n  issueCount\n}\n\nfragment WidgetTeamScheduleRoutineListItemContent_Routine on Routine {\n  id\n  description\n  title\n  isOrg\n  orgIconUri\n  descriptionImages {\n    size(minHeight: 120, minWidth: 120) {\n      url\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetTeamScheduleRoutineListItemContent_RoutineOccasion on RoutineOccasion {\n  startAt\n  deadlineAt\n  assigned {\n    id\n    employee {\n      id\n      name\n      isLinkedToViewer\n      ...Avatar_employee\n      ...ToolbarButtonAssignees_employees\n      ...ListItemAssignees_employees\n    }\n  }\n  assignedRoles {\n    role {\n      id\n      name\n      isLinkedToViewer\n      employeeIds\n      ...ToolbarButtonAssignees_roles\n      ...ListItemAssignees_roles\n    }\n    id\n  }\n}\n\nfragment WidgetTeamScheduleRoutineOccasionListItem_item on RoutineOccasion {\n  id\n  ...RoutineOccasionStatusCircle_RoutineOccasion\n  ...WidgetTeamScheduleRoutineIssueIndicator_routineOccasion\n  ...WidgetTeamScheduleRoutineListItemContent_RoutineOccasion\n  totalTaskExecutionCount\n  sequenceNumber\n  routine {\n    id\n    ...WidgetTeamScheduleRoutineListItemContent_Routine\n  }\n}\n\nfragment WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  totalTaskExecutionCount\n}\n\nfragment WidgetTeamSchedule_widget on WidgetTeamSchedule {\n  id\n  overviewSize\n  title\n  teams {\n    id\n    color\n  }\n  content {\n    __typename\n    ... on WidgetTeamScheduleContentDaily {\n      ...WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily\n    }\n    ... on WidgetTeamScheduleContentWeekly {\n      ...WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly\n    }\n    ... on WidgetTeamScheduleContentMonthly {\n      ...WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly\n    }\n    ... on WidgetTeamScheduleContentSummary {\n      ...WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary\n    }\n  }\n}\n\nfragment useNowIndexes_teamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  startAt\n}\n\nfragment useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  id\n  ... on TeamScheduleInlineRoutineOccasion {\n    taskExecution {\n      routine {\n        id\n      }\n      id\n    }\n  }\n  ... on RoutineOccasion {\n    routine {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3e6a05cf49a25ac0ee892103a2715772";

export default node;
